













import { defineComponent } from "vue";
import UiButton from "@dpa-id-components/ui-button";
import FilterBadge from "@dpa-id-components/dpa-filter-badge";
import useSaveSearchButton from "@/composition/useSaveSearchButton";

export default defineComponent({
  components: { UiButton, FilterBadge },
  setup() {
    const { setShowFilterDialog } = useSaveSearchButton();

    return { setShowFilterDialog };
  }
});
